// extracted by mini-css-extract-plugin
export var collapse = "CollapsingCard-module--collapse--341bu";
export var collapseCard = "CollapsingCard-module--collapseCard--38g4D";
export var collapseCardContent = "CollapsingCard-module--collapseCardContent--2p1Sq";
export var Card = "CollapsingCard-module--Card--1r1AR";
export var CollapsingCard = "CollapsingCard-module--CollapsingCard--3isec";
export var thumbnailContainer = "CollapsingCard-module--thumbnailContainer--1w15u";
export var header = "CollapsingCard-module--header--3KRiU";
export var time = "CollapsingCard-module--time--UTfSP";
export var title = "CollapsingCard-module--title--33Bz7";
export var textContainer = "CollapsingCard-module--textContainer--1FGJx";
export var infos = "CollapsingCard-module--infos--2l7Vt";
export var more = "CollapsingCard-module--more--TboTW";